var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile",class:{'tile-empty': _vm.emptyTile},style:({backgroundColor: _vm.backgroundColor})},[_vm._v("\n  "+_vm._s(_vm.displayingValue)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }